import { merge } from 'lodash-es'
import { isPitcherWkWebView } from '@lib/util/userAgents'
import { DEFAULT_PITCHER_SETTINGS } from '@lib/constants/pitcherSettings.const'
import type { OrganizationSettings } from '@lib/types/organizationSettings.types'
import type { InstanceSettings } from '@lib/types/instanceSettings.types'

export const createPitcherSettings = (
  organizationSettings: OrganizationSettings,
  instanceSettings: InstanceSettings,
) => {
  return merge(
    {}, // Start with an empty object to ensure no mutation occurs
    DEFAULT_PITCHER_SETTINGS, // Base settings
    organizationSettings, // Organization-level settings
    isPitcherWkWebView ? organizationSettings.ios : {}, // Instance-level ios overrides
    // organizationSettings?.settings.ios?.iPadMini, // Organization-level ipadMini overrides
    instanceSettings, // Instance-level settings
    isPitcherWkWebView ? instanceSettings.ios : {}, // Instance-level ios overrides
    // instanceSettings?.settings?.ios?.iPadMini, // Instance-level ipadMini overrides
  )
}
